import { Suspense } from 'react';
import { useTranslation } from '@/lib/i18n';
import { ShareFacebookIcon } from './assets/share-facebook-icon';
import { ShareXIcon } from './assets/share-x-icon';
import { ShareLinkedInIcon } from './assets/share-linkedin-icon';
import { ShareInstagramIcon } from './assets/share-instagram-icon';
import { DivWithPrimaryColorVariable } from './div-with-primary-color-variable';
import { WorldcooLogo } from '@worldcoo/ui/custom/worldcoo-logo';
import { useIsInframe } from '@/lib/use-is-in-iframe';
import { Link } from '@tanstack/react-router';
import { usePortalContext } from '@/lib/use-portal-context';

export function Footer() {
	return (
		<Suspense>
			<SuspensedFooter />
		</Suspense>
	);
}

function SuspensedFooter() {
	const { portalId } = usePortalContext();
	const { i18n } = useTranslation();
	const isInIframe = useIsInframe();
	if (isInIframe) return;

	return (
		<DivWithPrimaryColorVariable className="bg-primary">
			<div className="mx-auto flex max-w-[1366px] flex-col items-center justify-between gap-6 px-8 py-8 lg:flex-row lg:px-20">
				<a
					href="https://www.worldcoo.com"
					className="text-primary-foreground flex items-center gap-0.5 text-sm font-light"
				>
					{i18n.footer.poweredBy}
					<WorldcooLogo
						className="text-primary-foreground h-[35px] w-auto"
						accentClassName="text-primary-foreground/60"
					/>
				</a>

				<div className="text-primary-foreground flex flex-col gap-3 text-sm font-light lg:flex-row">
					<span>{i18n.footer.copyright.replace('{{year}}', new Date().getFullYear().toString())}</span>
					<Link to="/$portalId/terms" params={{ portalId }} className="underline" onClick={() => window.scrollTo(0, 0)}>
						{i18n.footer.termsAndConditions}
					</Link>
					<Link
						to="/$portalId/privacy"
						params={{ portalId }}
						className="underline"
						onClick={() => window.scrollTo(0, 0)}
					>
						{i18n.footer.privacyPolicy}
					</Link>
				</div>
				<nav>
					<ul className="flex gap-4">
						<li>
							<a href="https://www.facebook.com/worldcoo/" target="_blank" rel="noopener noreferrer">
								<span className="sr-only">Facebook</span>
								<ShareFacebookIcon className="text-primary" />
							</a>
						</li>

						<li>
							<a href="https://twitter.com/worldcoo" target="_blank" rel="noopener noreferrer">
								<span className="sr-only">Twitter</span>
								<ShareXIcon className="text-primary" />
							</a>
						</li>

						<li>
							<a href="https://www.instagram.com/worldcoo/" target="_blank" rel="noopener noreferrer">
								<span className="sr-only">Instagram</span>
								<ShareInstagramIcon className="text-primary" />
							</a>
						</li>

						<li>
							<a href="https://www.linkedin.com/company/worldcoo" target="_blank" rel="noopener noreferrer">
								<span className="sr-only">LinkedIn</span>
								<ShareLinkedInIcon className="text-primary" />
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</DivWithPrimaryColorVariable>
	);
}
